<template>
  <div class="d-flex flex-column check-in-sheet-company-select justify-center align-center">
    <error-alert :message.sync="error" dismissible />
    <v-card width="400">
      <v-card-title> New Check in Sheet </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedCompany"
          @change="changeCompany"
          :items="companies"
          placeholder="Enter Company Name"
        >
        </v-autocomplete>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn class="red white--text px-3" @click="$router.back()">
          Cancel
        </v-btn>
        <v-btn class="green white--text px-3" @click="createCheckInSheet">
          Next
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { extractDataAxios, extractErrorMessageAxios } from "@/httpClient";
import { mapActions } from "@/store/modules/checkInSheet";
import ErrorAlert from "@/components/ErrorAlert";

export default {
  name: "CreateCheckInSheet",
  async mounted() {
    this.companies = extractDataAxios(await window.axios.get("/api/companies"));
  },
  components: {
    ErrorAlert,
  },
  data() {
    return {
      companies: [],
      selectedCompany: "",
      checkInSheet: null,
      error: null,
      validationMessage: null,
    };
  },
  methods: {
    ...mapActions(["changeCompany", "addCheckInSheet"]),
    async createCheckInSheet() {
      try {
        const response = await window.axios.post("/api/check-in-sheet", {
          company_name: this.selectedCompany,
        });
        this.checkInSheet = extractDataAxios(response);
        this.addCheckInSheet(this.checkInSheet);
        this.$router.push({ name: "single-check-in-sheet", params: { id: this.checkInSheet.id } });
      } catch (e) {
        this.error = extractErrorMessageAxios(e);
      }
    },
  },
};
</script>

<style scoped>
.check-in-sheet-company-select {
  height: 80vh;
}
</style>
